import { Observable } from 'rxjs/Observable';
import { RequestPoliticaTermo } from '../classes/RequestPoliticaTermo';
import { ResponsePoliticaTermo } from '../classes/ResponsePoliticaTermo';
import { HttpService } from '../services';

export namespace PoliticaTermoBi {

    export class Parser {
        public static fill(origin: any): ResponsePoliticaTermo {
            const responseTermo: ResponsePoliticaTermo = Object.assign(new ResponsePoliticaTermo(), origin);
            return responseTermo;
        }
    }

    export class Rest {
        constructor(private httpService: HttpService) { }

        public acceptanceCheck(usuarioUuid: string, usuarioId: number): Observable<any> {
            return this.httpService.pathV2().get('termos/' + usuarioUuid + '/' + usuarioId, true);
        }

        public acceptTerm(accept: RequestPoliticaTermo): Observable<any> {
            return this.httpService.pathV2().post('termos/insert', accept, true);
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/resources/bi/PoliticaTermo.bi.ts